import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ProductService } from '../shared/services/catalog.service';

// Pointer to Google Analytics gTag function defined in index.html
declare let gtag: Function;

/** PDF Viewer  */
@Component({
    selector: 'pd-viewer',
    templateUrl: './viewer.component.html',
    styleUrls: ['./viewer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewerComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    fileName = "HCAT-product.pdf";
    pdfLoadError = false;
    pdfLoading = true;
    id: string = '';
    category: string = '';
    autoDownload = false;

    @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand: any;

    get loading(): boolean {
        return this.pdfLoading;
    }

    get loadError(): boolean {
        return this.pdfLoadError;
    }

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private changeDetectorRef: ChangeDetectorRef,
        private productService: ProductService
    ) { }

    ngOnInit() {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
            if (params['id']) {
                this.id = params['id'];

                if (params['download']) {
                    this.autoDownload = true;
                }

                this.fileName = 'HCAT-product-' + this.id + '.pdf';

                this.productService.catalogUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
                    if (list) {
                        let tableList: any[] = list;

                        for (let index = 0; index < tableList.length; index++) {
                            const element = tableList[index];
                            if ( element.item.toString() === this.id ) {
                                this.category = element['category'];

                                gtag('event', 'pdf_view', {
                                    'event_label' : element['name'],
                                    'product_id': this.id
                                });

                                break;
                            }
                        }

                        if ( this.category ) {
                            this.loadDataSheet();
                        } else {
                            this.pdfLoading = false;
                            this.pdfLoadError = true;
                        }
                    } else {
                        this.pdfLoadError = this.productService.loadFailed;
                        if (!this.pdfLoadError) {
                            this.productService.refresh();
                        } else {
                            this.pdfLoading = false;
                        }
                    }
                });
            } else {
                this.pdfLoadError = true;
                this.pdfLoading = false;
                this.changeDetectorRef.detectChanges();
            }
        });
    }

    loadDataSheet(): void {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };

        this.http.post<any>(environment.azure.url + '/datasheet', {
            id: this.id,
            category: this.category
        }, options)
            .subscribe({
                next: (data) => {
                    this.pdfLoading = false;
                    this.pdfLoadError = false;

                    this.pdfViewerOnDemand.pdfSrc = this.convertDataURIToBinary(data.documentBytes);
                    this.pdfViewerOnDemand.refresh();

                    this.changeDetectorRef.detectChanges();
                },
                error: (msg) => {
                    this.pdfLoading = false;
                    this.pdfLoadError = true;

                    this.changeDetectorRef.detectChanges();
                    console.log(msg);
                }
            });
    }

    convertDataURIToBinary(dataURI: string) {
        var raw = window.atob(dataURI);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));

        for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
